import { useQuery } from "react-query";
import API from "../shared-utils/api";
const getTableLayoutSvg = async (pubId) => {
    if (!pubId)
        return "";
    const { data } = await API.get(`api/v1/rbzo/pubs/table/getTableLayoutUrl?pubId=${pubId}`);
    return (data === null || data === void 0 ? void 0 : data.status_code) === "OK" ? data === null || data === void 0 ? void 0 : data.data : "";
};
export const useTableLayoutSvg = (pubId) => {
    return useQuery(["table_layout_svg", pubId], () => getTableLayoutSvg(pubId), {
        enabled: !!pubId,
        staleTime: 0,
        cacheTime: 0,
        refetchOnWindowFocus: false,
    });
};
